import React from 'react'
import PropTypes from 'prop-types'
import Button from '@boltui/button'
import * as Styled from './PageNotFound.styles'

const PageNotFound = ({ heading, subHeading, links, 'data-test': dataTest }) => {
  return (
    <Styled.Container data-test={dataTest}>
      <h1>{heading}</h1>
      <p>{subHeading}</p>
      <Styled.ButtonsContainer>
        {links.map((link, index) => (
          <a
            key={`${link.href}-${link.text}`}
            title={link.title}
            className='page-not-found-button-link'
            onClick={(evt) => (typeof link.handler === 'function' ? link.handler(evt, link.href) : false)}
            href={link.href}>
            <Button data-test={`${dataTest}-component=button-${index}`} kind='secondary' full>
              {link.text}
            </Button>
          </a>
        ))}
      </Styled.ButtonsContainer>
    </Styled.Container>
  )
}

PageNotFound.propTypes = {
  /**
   * Custom heading
   */
  heading: PropTypes.string,
  /**
   * Custom subheading
   */
  subHeading: PropTypes.string,
  /**
   * Send in your own array of objects for all needed links
   */
  links: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      href: PropTypes.string,
      title: PropTypes.string,
      handler: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
    })
  )
}

PageNotFound.defaultProps = {
  heading: "Oops, that didn't go to plan",
  subHeading: "We can't seem to find that page right now...",
  links: [
    {
      text: 'Take me home',
      href: '//www.argos.co.uk',
      title: 'Take me home: Argos Homepage',
      handler: {}
    },
    {
      text: 'Contact us',
      href: '//www.argos.co.uk/help',
      title: 'Contact us: Argos help pages',
      handler: {}
    }
  ],
  'data-test': 'component-page-not-found'
}

export default PageNotFound
